import React from 'react';
import i18n from '../../i18n';
import {withFormik} from 'formik';
import axios from 'axios';
import {Card, CardContent, Typography, withStyles} from '@material-ui/core';
import {mergeWithDefault} from '../Form/utils';
import swal from 'sweetalert';
import {array, object, string, number, boolean, required} from 'yup';
import FormFields from './FormFields';
import GlobalContext from '../../globalContext';
import MediaDropButton from '../Media/DropButton';
import Divider from '@material-ui/core/Divider';
import {useMutation} from '@apollo/react-hooks';
import _ from 'lodash';
import attachmentReferenceMutations from '../../mutations/attachmentReferenceMutations';
import buildingMutations from '../../mutations/contractMutations';
import moment from 'moment';
import {getMutationName} from '../Form/utils';
import SaveEvent from '../SaveShortcut/FunctionComponent';
import contractBuildingMutations from "../../mutations/contractBuildingMutations";
import contractQueries from "../../queries/contractQueries";

const saveAttachment = async (fileData, contract_id) => {
    const mutation = attachmentReferenceMutations.createAttachmentReference;

    const {data: result} = await window.apolloClient.mutate({mutation, variables: {contract_id, attachment_id: fileData.id}});
    return result['createAttachmentReference'];
};

const saveContractBuildings = async (contractId,values) => {

    const mutation = contractBuildingMutations.createContractBuilding;
    const queryName = getMutationName(mutation);
    const buildings = values.buildings;
    const buildingsTrash = values.buildingsTrash;

    let trash = buildingsTrash.map(item => {
        return item.id;
    })

    let query = contractQueries.deleteBuildings;
    let variables = {id:trash};
    await window.apolloClient.query({ query , variables , errorPolicy:'all'});

    if(buildings && buildings.length){
        await buildings.map(async building => {
            await window.apolloClient.mutate({
                mutation,
                variables: {
                    //id: values.building_id || null,
                    contract_id: contractId || null,
                    building_id: building.value || null,
                    notice: building.notice || null,
                },
                errorPolicy: "all"
            })
        })
    }
    return values;
};

const manipulateValuesBeforeSave = async (values) => {

    ['date_of_contract','warranty_period_start','warranty_period_end'].forEach((item, idx) => {
        if ( values[item] === '' ) {
            values[item] = null;
        } else {
            values[item] = moment(values[item]).format('YYYY-MM-DD HH:mm:ss');
        }
    });

    values["updated_at"] = moment().format('YYYY-MM-DD HH:mm:ss');

    return values;
};

const saveContract = async ({files,...values}) => {
    const mutation = values.id > 0 ? buildingMutations.updateContract : buildingMutations.createContract;
    let data = await manipulateValuesBeforeSave(values);

    const {data: result} = await window.apolloClient.mutate({mutation, variables: {...data},errorPolicy: "all"});

    const queryName = getMutationName(mutation);
    const contractId = _.get(result, queryName + '.id');

    if(values.building_id)  {
        await saveContractBuildings(contractId,values);
    }

    if (files && files.length > 0) {
        _.each(files, (fileData, idx) => {
            saveAttachment(fileData, contractId);
        });
    }

    return result[queryName];
};

const yupLabel = (name) => {
    return i18n.get('contract.form.' + name);
};

const ContractForm = (props) => {
    const {
        values,
        setFieldValue,
        handleSubmit,
        uploadConfig,
        classes,
    } = props;

    SaveEvent({handleSubmit});

    return (
        <form onSubmit={handleSubmit}>
            <FormFields {...props}>
                <Divider className={classes.divider}/>

                {uploadConfig && (
                    <React.Fragment>
                        <MediaDropButton
                            uploadConfig={uploadConfig}
                            entity={{label:'contract_id', id: values.id }}
                            onNewFile={(file) => {
                                values.files.push(file);
                                setFieldValue('files', values.files);
                            }}
                        />
                        <Divider className={classes.divider}/>
                    </React.Fragment>
                )}
            </FormFields>
        </form>
    );
};

const FormConfig = withFormik({
    mapPropsToValues: props => mergeWithDefault(props.values, {
        id: '',
        date_of_contract: '',  /** Date */
        warranty_period_start: '',    /** Date */
        warranty_period_end: '',      /** Date */
        building_id: '',
        building: null,
        building_trashed: '',
        buildings:[],
        buildingsTrash: props.values.buildings,
        contact_id: '',
        contact: null,
        user_id: window.__DATA__._user.id,
        files: [],
    }),
    validationSchema: () => {
        let rules = {
            date_of_contract: string().label(yupLabel('date_contract_conclusion')).required(),
            warranty_period_start: string().label(yupLabel('warranty_period_start')).required(),
            warranty_period_end: string().label(yupLabel('warranty_period_end')).required(),
            contact_id: number().label(yupLabel('client')).required(),
            building_id: number().label(yupLabel('construction_project')).required(),
            buildings: array().label(yupLabel('building')).min(1).required(),
        };
        return object().shape(rules);
    },
    handleSubmit: (values, {setSubmitting, ...props}) => {
        setSubmitting(true);
        saveContract(values).then(data => {
            setSubmitting(false);
            // Show success message.
            return swal({
                text: i18n.get('contract.msg.save_success'),
                icon: 'success',
                timer: 4000,
            }).then(() => {

                if (data.id > 0) {
                    window.location.href = `/contract`;
                }
            });

        });
    },
    validateOnBlur: true,
})(ContractForm);

const styles = theme => ({
    deleteButton: {
        background: theme.colors.error,
    },
    sub_project: {
        marginTop: theme.spacing.unit * 2,
        marginBottom: theme.spacing.unit * 2,
    },
    divider: {
        marginTop: theme.spacing.unit * 2,
    },
});

export default withStyles(styles)(FormConfig);
